import { render } from "./update-workposition.vue?vue&type=template&id=c28c62b4&scoped=true"
import script from "./update-workposition.vue?vue&type=script&lang=js"
export * from "./update-workposition.vue?vue&type=script&lang=js"

import "./update-workposition.vue?vue&type=style&index=0&id=c28c62b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28c62b4"],['__file',"src/components/applications/workorganisation/update-workposition.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c28c62b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c28c62b4', __exports__)) {
    api.reload('c28c62b4', __exports__)
  }
  
  module.hot.accept("./update-workposition.vue?vue&type=template&id=c28c62b4&scoped=true", () => {
    api.rerender('c28c62b4', render)
  })

}


export default __exports__